import axios from 'axios';

const api = axios.create({
  baseURL: "https://manager.cromoconstrutora.com.br",
});

export default api;